import React, {useEffect, useState} from "react";
import {PageTitle} from "../../../Components/Landmarks";
import {userProfileApi} from "./userProfileApi";
import {UserProfileView} from "./UserProfileView";
import {isNullOrUndefined} from "../../../Utilities/commonUtilities";
import {userDetailsModel} from "../UserDetails/userDetailsFactory";
import {locations} from "../../../Utilities/Location";
import {allow, policyEvents} from "../../../Components/Authorize";
import {updateFullName} from "../../../Utilities/LocalStorage/storageUtilities";

import type { ListItem } from "../../../Utilities/Types/listUtilities";

import type {User} from "../../../types";

interface UserProfileContainerProps {
    districts: { id: string; districtName: string }[];
    handleApiCall: (...args: unknown[]) => void;
    isLoading: boolean;
    patronId: string;
    redirect: (path: string) => void;
    setWarnings: (val: string[]) => void;
    userId: string;
}

export const UserProfileContainer: React.FC<UserProfileContainerProps> = ({
                                         districts,
                                         handleApiCall,
                                         isLoading,
                                         patronId,
                                         redirect,
                                         setWarnings,
                                         userId
                                     }) => {

    const [userDetails, setUserDetails] = useState<User | null>(null);

    const clearUserDetailsState = () => {
        setUserDetails(null);
    };

    const handleEditUser = (userDetails: Record<string, unknown>) => {

        const userDetailsToUpdate = userDetailsModel(
            {
                ...userDetails,
                patronRole: userDetails.jobTitle
            });

        handleApiCall(() => userProfileApi.editUserDetails(userDetailsToUpdate, userId), () => {
            if (userId === patronId) {
                updateFullName(userDetailsToUpdate.firstName, userDetailsToUpdate.lastName);
            }
            allow(policyEvents.APPROVE_USERS) ? redirect(locations.USER_MANAGEMENT.path) : redirect(locations.DASHBOARD.path);
        });
    };

    const loadUserDetailsResult = (result: Record<string, unknown>) => {
        const userDetails = userDetailsModel({...result});
        setUserDetails(userDetails);
    };

    useEffect(() => {

        const loadUserDetails = () => {
            handleApiCall(() => userProfileApi.getUserDetails(patronId, userId), loadUserDetailsResult)
        };

        clearUserDetailsState();
        loadUserDetails();
    }, [patronId]);


    if (!districts)
        return null;

    return <>
        <PageTitle h1={`User Profile Update`}/>
        {
            !isNullOrUndefined(userDetails) &&
            <UserProfileView
                districts={districts}
                handleEditUser={handleEditUser}
                isLoading={isLoading}
                redirect={redirect}
                setWarnings={setWarnings}
                patronDetails={userDetails}
            />
        }
    </>;
};